import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

import { Component, OnInit, Renderer2, Inject, PLATFORM_ID, Input, Output, ViewChild, ElementRef, HostListener, EventEmitter } from '@angular/core';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { UtilsService } from '../../services/utils.service';
import { SafePipe } from '../../pipes/safe.pipe';
import { SafehtmlPipe } from '../../pipes/safehtml.pipe';
import { TruncatePipe } from '../../pipes/truncate.pipe';
@Component({
  selector: 'app-carousal-page',
  standalone:true,
  imports:[CommonModule,CarouselModule,RouterModule, SafehtmlPipe,SafePipe,TruncatePipe],
  templateUrl: './carousal-page.component.html',
  styleUrl: './carousal-page.component.scss'
})
export class CarousalPageComponent implements OnInit {
  constructor(private renderer: Renderer2, public utils: UtilsService,@Inject(DOCUMENT) private _document: Document,private el: ElementRef,
  private router:Router,private sanitizer: DomSanitizer, @Inject(PLATFORM_ID) private platformId: Object) { }
  @Input() genericCarousel!: boolean;
  @Input('isProductCarousel') isProductCarousel!: boolean;
  @Input('isCategoryCarousel') isCategoryCarousel!: boolean;
  @Input('isPDPCarousel') isPDPCarousel!: boolean;
  @Input('isOurLeaderCarousel') isOurLeaderCarousel!: boolean;
  @Input('frequentlyBought') frequentlyBought!: boolean;
  @Input('carouselSlideData') carouselSlideData: any;
  @Input() centered!: boolean;
  @Output() imageClicked = new EventEmitter<{}>();
  @Output() emitValue = new EventEmitter<{}>();
  @Output() catClicked = new EventEmitter<{}>();
  @ViewChild('carousel') carousel!: ElementRef;
  @Input('isEshop') isEshop!: boolean;

  customOptionsForOurLeaderSection: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 600,
    nav: true,
    navText: ['', ''],
    stagePadding: 50,
    margin: 25,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      768: {
        items: 3,
      },
      1100: {
        items: 4
      },
    },
  };
  environment: any = environment;
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 600,
    nav: true,
    navText: ['', ''],
    stagePadding: 50,
    margin: 25,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1000: {
        items: 3
      },
    },
  };
  genericOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    autoplay: false,
    dots: true,
    navSpeed: 600,
    nav: true,
    stagePadding: 50,
    margin: 25,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      575: {
        items: 2
      },
      768: {
        items: 2
      },
      900: {
        items: 3
      },
      1200: {
        items: 4
      },
    },
  };
  achievementData:any = [{
    image: environment.blobUrl+'/assets/images/career/details-image.webp',
    title: 'Market Penetration Leadership Award',
    description: 'Ever witnessed unusual heating of InverterBattery at home? Although most  ...'
  },
  {
    image:  environment.blobUrl+'/assets/images/career/details-image.webp',
    title: 'Market Penetration Leadership Award',
    description: 'Ever witnessed unusual heating of InverterBattery at home? Although most  ...'
  }
  ];
  actualSchemaValue:any;
  script:any;
  structuredData!: SafeHtml;
  ngOnInit(): void {
    this.achievementData = this.carouselSlideData && this.carouselSlideData.length ? this.carouselSlideData : this.achievementData;
    if (this.achievementData && this.achievementData.length == 1) {
      this.genericOptions.margin = 0;
      this.genericOptions.nav = false;
      this.genericOptions.autoWidth = true;
      this.genericOptions.responsive = {
        0: {
          items: 1
        }
      }
    }
    if(this.carouselSlideData != '' && this.carouselSlideData != undefined && this.carouselSlideData != null) {
      this.carouselSlideData.forEach((ele:any) => {
        if(ele && (ele.embededLink || ele.videoTitle)){
        }else{}
      })
    }
  }

  @HostListener('window:resize', ['$event'])
  screenWidth() {
    this.setOwlPrevPosition();
  }

  ngAfterViewInit() {
    this.setOwlPrevPosition();
    if (this.isEshop === true) {
      setTimeout(() => {
        const owlItems = this.el.nativeElement.querySelectorAll('.owl-item');
        owlItems.forEach((item: HTMLElement) => {
          if (item.style.width === '325px') {
            this.renderer.setStyle(item, 'width', '280px');
            item.setAttribute('nonce', 'lumi12');
          }
        });
      }, 500);
    }
  }

  setOwlPrevPosition() {
    if (this.carousel && this.carousel.nativeElement) {
      let dotsWidth = this.carousel.nativeElement.getElementsByClassName('owl-dots')[0].clientWidth;
      let prev = this.carousel.nativeElement.getElementsByClassName('owl-prev')[0];
      this.renderer.setStyle(prev, 'right', dotsWidth + 35 + 'px');
      prev.setAttribute('nonce', 'lumi12');
    }
  }

  onImageClick(data: any) {
    this.imageClicked.emit(data);
  }

  getProductLink(data: any, isPdpPage?: boolean) {
    let url = ''
    if (isPdpPage) {
      let name = this.utils.createNameForUrl(data.productName ? data.productName : '');
      url = `/product/${name}`;
    }
    else {
      if (this.isCategoryCarousel) {
        let name = this.utils.createNameForUrl(data.description ? data.description : '')
        url = `/product-listing/shop-now/${name}`
      }
      else {
        let name = this.utils.createNameForUrl(data.description ? data.description : '')
        url = `/product/${name}`;
      }
    }
    return url;
  }

  onValueEmit(data: any, productName: any) {
    this.emitValue.emit({ productGuidId: data, productName: productName })
  }

  onCatClick() {
    this.catClicked.emit(true);
  }

}